import Divider from "components/Atoms/Divider"
import React from "react"
import TimeslotThreshold from "./TimeslotThreshold"
import FormLayout from "./FormLayout"
import TimeSlider from "./TimeSlider"
const OperatingHours = () => {
  return (
    <FormLayout title="Operational Slots">
      <TimeSlider id="deliverySlots">
        <Divider
          dashed
          className="mt-6 mb-2"
          style={{
            borderColor: "#999999",
          }}
        />
        <TimeslotThreshold path="deliverySlots" type="delivery" />
      </TimeSlider>
      <TimeSlider id="pickupSlots">
        <Divider
          dashed
          className="mt-6 mb-2"
          style={{
            borderColor: "#999999",
          }}
        />
        <TimeslotThreshold path="pickupSlots" type="pickup" />
      </TimeSlider>
      <TimeSlider id="maintenanceSlots" />
      <TimeSlider id="alternateSalesSlots" />
    </FormLayout>
  )
}

export default OperatingHours
